/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApplicationResponseBaseResponse as ModelsV4ApplicationApplicationResponseBaseResponse } from '../models/Models/v4/Application/application-response-base-response';
import { ApplicationWithdrawRequestBaseResponse as ModelsV4ApplicationApplicationWithdrawRequestBaseResponse } from '../models/Models/v4/Application/application-withdraw-request-base-response';
import { LoanFileRequestBaseResponse as ModelsV4ApplicationLoanFileRequestBaseResponse } from '../models/Models/v4/Application/loan-file-request-base-response';
import { ApplicationUpdateBaseResponseBaseResponse as ModelsV4ApplicationPublicApplicationUpdateBaseResponseBaseResponse } from '../models/Models/v4/Application/Public/application-update-base-response-base-response';
import { v4ApplicationVehicleApplicationIdFilePost$Json } from '../fn/vehicle-application/v-4-application-vehicle-application-id-file-post-json';
import { V4ApplicationVehicleApplicationIdFilePost$Json$Params } from '../fn/vehicle-application/v-4-application-vehicle-application-id-file-post-json';
import { v4ApplicationVehicleApplicationIdFilePost$Plain } from '../fn/vehicle-application/v-4-application-vehicle-application-id-file-post-plain';
import { V4ApplicationVehicleApplicationIdFilePost$Plain$Params } from '../fn/vehicle-application/v-4-application-vehicle-application-id-file-post-plain';
import { v4ApplicationVehicleApplicationIdFilePost$Xml } from '../fn/vehicle-application/v-4-application-vehicle-application-id-file-post-xml';
import { V4ApplicationVehicleApplicationIdFilePost$Xml$Params } from '../fn/vehicle-application/v-4-application-vehicle-application-id-file-post-xml';
import { v4ApplicationVehicleApplicationIdPut$Json } from '../fn/vehicle-application/v-4-application-vehicle-application-id-put-json';
import { V4ApplicationVehicleApplicationIdPut$Json$Params } from '../fn/vehicle-application/v-4-application-vehicle-application-id-put-json';
import { v4ApplicationVehicleApplicationIdPut$Plain } from '../fn/vehicle-application/v-4-application-vehicle-application-id-put-plain';
import { V4ApplicationVehicleApplicationIdPut$Plain$Params } from '../fn/vehicle-application/v-4-application-vehicle-application-id-put-plain';
import { v4ApplicationVehicleApplicationIdWithdrawPost$Json$Json } from '../fn/vehicle-application/v-4-application-vehicle-application-id-withdraw-post-json-json';
import { V4ApplicationVehicleApplicationIdWithdrawPost$Json$Json$Params } from '../fn/vehicle-application/v-4-application-vehicle-application-id-withdraw-post-json-json';
import { v4ApplicationVehicleApplicationIdWithdrawPost$Json$Plain } from '../fn/vehicle-application/v-4-application-vehicle-application-id-withdraw-post-json-plain';
import { V4ApplicationVehicleApplicationIdWithdrawPost$Json$Plain$Params } from '../fn/vehicle-application/v-4-application-vehicle-application-id-withdraw-post-json-plain';
import { v4ApplicationVehicleApplicationIdWithdrawPost$Json$Xml } from '../fn/vehicle-application/v-4-application-vehicle-application-id-withdraw-post-json-xml';
import { V4ApplicationVehicleApplicationIdWithdrawPost$Json$Xml$Params } from '../fn/vehicle-application/v-4-application-vehicle-application-id-withdraw-post-json-xml';
import { v4ApplicationVehicleApplicationIdWithdrawPost$Xml$Json } from '../fn/vehicle-application/v-4-application-vehicle-application-id-withdraw-post-xml-json';
import { V4ApplicationVehicleApplicationIdWithdrawPost$Xml$Json$Params } from '../fn/vehicle-application/v-4-application-vehicle-application-id-withdraw-post-xml-json';
import { v4ApplicationVehicleApplicationIdWithdrawPost$Xml$Plain } from '../fn/vehicle-application/v-4-application-vehicle-application-id-withdraw-post-xml-plain';
import { V4ApplicationVehicleApplicationIdWithdrawPost$Xml$Plain$Params } from '../fn/vehicle-application/v-4-application-vehicle-application-id-withdraw-post-xml-plain';
import { v4ApplicationVehicleApplicationIdWithdrawPost$Xml$Xml } from '../fn/vehicle-application/v-4-application-vehicle-application-id-withdraw-post-xml-xml';
import { V4ApplicationVehicleApplicationIdWithdrawPost$Xml$Xml$Params } from '../fn/vehicle-application/v-4-application-vehicle-application-id-withdraw-post-xml-xml';
import { v4ApplicationVehicleBrokerPost$Json$Json } from '../fn/vehicle-application/v-4-application-vehicle-broker-post-json-json';
import { V4ApplicationVehicleBrokerPost$Json$Json$Params } from '../fn/vehicle-application/v-4-application-vehicle-broker-post-json-json';
import { v4ApplicationVehicleBrokerPost$Json$Plain } from '../fn/vehicle-application/v-4-application-vehicle-broker-post-json-plain';
import { V4ApplicationVehicleBrokerPost$Json$Plain$Params } from '../fn/vehicle-application/v-4-application-vehicle-broker-post-json-plain';
import { v4ApplicationVehicleBrokerPost$Json$Xml } from '../fn/vehicle-application/v-4-application-vehicle-broker-post-json-xml';
import { V4ApplicationVehicleBrokerPost$Json$Xml$Params } from '../fn/vehicle-application/v-4-application-vehicle-broker-post-json-xml';
import { v4ApplicationVehicleBrokerPost$Xml$Json } from '../fn/vehicle-application/v-4-application-vehicle-broker-post-xml-json';
import { V4ApplicationVehicleBrokerPost$Xml$Json$Params } from '../fn/vehicle-application/v-4-application-vehicle-broker-post-xml-json';
import { v4ApplicationVehicleBrokerPost$Xml$Plain } from '../fn/vehicle-application/v-4-application-vehicle-broker-post-xml-plain';
import { V4ApplicationVehicleBrokerPost$Xml$Plain$Params } from '../fn/vehicle-application/v-4-application-vehicle-broker-post-xml-plain';
import { v4ApplicationVehicleBrokerPost$Xml$Xml } from '../fn/vehicle-application/v-4-application-vehicle-broker-post-xml-xml';
import { V4ApplicationVehicleBrokerPost$Xml$Xml$Params } from '../fn/vehicle-application/v-4-application-vehicle-broker-post-xml-xml';
import { v4ApplicationVehiclePost$Json$Json } from '../fn/vehicle-application/v-4-application-vehicle-post-json-json';
import { V4ApplicationVehiclePost$Json$Json$Params } from '../fn/vehicle-application/v-4-application-vehicle-post-json-json';
import { v4ApplicationVehiclePost$Json$Plain } from '../fn/vehicle-application/v-4-application-vehicle-post-json-plain';
import { V4ApplicationVehiclePost$Json$Plain$Params } from '../fn/vehicle-application/v-4-application-vehicle-post-json-plain';
import { v4ApplicationVehiclePost$Json$Xml } from '../fn/vehicle-application/v-4-application-vehicle-post-json-xml';
import { V4ApplicationVehiclePost$Json$Xml$Params } from '../fn/vehicle-application/v-4-application-vehicle-post-json-xml';
import { v4ApplicationVehiclePost$Xml$Json } from '../fn/vehicle-application/v-4-application-vehicle-post-xml-json';
import { V4ApplicationVehiclePost$Xml$Json$Params } from '../fn/vehicle-application/v-4-application-vehicle-post-xml-json';
import { v4ApplicationVehiclePost$Xml$Plain } from '../fn/vehicle-application/v-4-application-vehicle-post-xml-plain';
import { V4ApplicationVehiclePost$Xml$Plain$Params } from '../fn/vehicle-application/v-4-application-vehicle-post-xml-plain';
import { v4ApplicationVehiclePost$Xml$Xml } from '../fn/vehicle-application/v-4-application-vehicle-post-xml-xml';
import { V4ApplicationVehiclePost$Xml$Xml$Params } from '../fn/vehicle-application/v-4-application-vehicle-post-xml-xml';

@Injectable({ providedIn: 'root' })
export class VehicleApplicationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `v4ApplicationVehiclePost()` */
  static readonly V4ApplicationVehiclePostPath = '/v4/application/vehicle';

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationVehiclePost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationVehiclePost$Json$Plain$Response(params?: V4ApplicationVehiclePost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4ApplicationVehiclePost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationVehiclePost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationVehiclePost$Json$Plain(params?: V4ApplicationVehiclePost$Json$Plain$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4ApplicationVehiclePost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationVehiclePost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationVehiclePost$Json$Json$Response(params?: V4ApplicationVehiclePost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4ApplicationVehiclePost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationVehiclePost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationVehiclePost$Json$Json(params?: V4ApplicationVehiclePost$Json$Json$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4ApplicationVehiclePost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationVehiclePost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationVehiclePost$Json$Xml$Response(params?: V4ApplicationVehiclePost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4ApplicationVehiclePost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationVehiclePost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationVehiclePost$Json$Xml(params?: V4ApplicationVehiclePost$Json$Xml$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4ApplicationVehiclePost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationVehiclePost$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationVehiclePost$Xml$Plain$Response(params?: V4ApplicationVehiclePost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4ApplicationVehiclePost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationVehiclePost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationVehiclePost$Xml$Plain(params?: V4ApplicationVehiclePost$Xml$Plain$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4ApplicationVehiclePost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationVehiclePost$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationVehiclePost$Xml$Json$Response(params?: V4ApplicationVehiclePost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4ApplicationVehiclePost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationVehiclePost$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationVehiclePost$Xml$Json(params?: V4ApplicationVehiclePost$Xml$Json$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4ApplicationVehiclePost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationVehiclePost$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationVehiclePost$Xml$Xml$Response(params?: V4ApplicationVehiclePost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4ApplicationVehiclePost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationVehiclePost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationVehiclePost$Xml$Xml(params?: V4ApplicationVehiclePost$Xml$Xml$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4ApplicationVehiclePost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /** Path part for operation `v4ApplicationVehicleBrokerPost()` */
  static readonly V4ApplicationVehicleBrokerPostPath = '/v4/application/vehicle/broker';

  /**
   * Starts new Vehicle application by a broker.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationVehicleBrokerPost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationVehicleBrokerPost$Json$Plain$Response(params?: V4ApplicationVehicleBrokerPost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4ApplicationVehicleBrokerPost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Vehicle application by a broker.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationVehicleBrokerPost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationVehicleBrokerPost$Json$Plain(params?: V4ApplicationVehicleBrokerPost$Json$Plain$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4ApplicationVehicleBrokerPost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Vehicle application by a broker.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationVehicleBrokerPost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationVehicleBrokerPost$Json$Json$Response(params?: V4ApplicationVehicleBrokerPost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4ApplicationVehicleBrokerPost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Vehicle application by a broker.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationVehicleBrokerPost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationVehicleBrokerPost$Json$Json(params?: V4ApplicationVehicleBrokerPost$Json$Json$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4ApplicationVehicleBrokerPost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Vehicle application by a broker.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationVehicleBrokerPost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationVehicleBrokerPost$Json$Xml$Response(params?: V4ApplicationVehicleBrokerPost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4ApplicationVehicleBrokerPost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Vehicle application by a broker.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationVehicleBrokerPost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationVehicleBrokerPost$Json$Xml(params?: V4ApplicationVehicleBrokerPost$Json$Xml$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4ApplicationVehicleBrokerPost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Vehicle application by a broker.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationVehicleBrokerPost$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationVehicleBrokerPost$Xml$Plain$Response(params?: V4ApplicationVehicleBrokerPost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4ApplicationVehicleBrokerPost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Vehicle application by a broker.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationVehicleBrokerPost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationVehicleBrokerPost$Xml$Plain(params?: V4ApplicationVehicleBrokerPost$Xml$Plain$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4ApplicationVehicleBrokerPost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Vehicle application by a broker.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationVehicleBrokerPost$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationVehicleBrokerPost$Xml$Json$Response(params?: V4ApplicationVehicleBrokerPost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4ApplicationVehicleBrokerPost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Vehicle application by a broker.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationVehicleBrokerPost$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationVehicleBrokerPost$Xml$Json(params?: V4ApplicationVehicleBrokerPost$Xml$Json$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4ApplicationVehicleBrokerPost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Vehicle application by a broker.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationVehicleBrokerPost$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationVehicleBrokerPost$Xml$Xml$Response(params?: V4ApplicationVehicleBrokerPost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4ApplicationVehicleBrokerPost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Vehicle application by a broker.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationVehicleBrokerPost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationVehicleBrokerPost$Xml$Xml(params?: V4ApplicationVehicleBrokerPost$Xml$Xml$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4ApplicationVehicleBrokerPost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /** Path part for operation `v4ApplicationVehicleApplicationIdPut()` */
  static readonly V4ApplicationVehicleApplicationIdPutPath = '/v4/application/vehicle/{applicationId}';

  /**
   * Update the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationVehicleApplicationIdPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationVehicleApplicationIdPut$Plain$Response(params: V4ApplicationVehicleApplicationIdPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationPublicApplicationUpdateBaseResponseBaseResponse>> {
    return v4ApplicationVehicleApplicationIdPut$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Update the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationVehicleApplicationIdPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationVehicleApplicationIdPut$Plain(params: V4ApplicationVehicleApplicationIdPut$Plain$Params, context?: HttpContext): Observable<ModelsV4ApplicationPublicApplicationUpdateBaseResponseBaseResponse> {
    return this.v4ApplicationVehicleApplicationIdPut$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationPublicApplicationUpdateBaseResponseBaseResponse>): ModelsV4ApplicationPublicApplicationUpdateBaseResponseBaseResponse => r.body)
    );
  }

  /**
   * Update the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationVehicleApplicationIdPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationVehicleApplicationIdPut$Json$Response(params: V4ApplicationVehicleApplicationIdPut$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationPublicApplicationUpdateBaseResponseBaseResponse>> {
    return v4ApplicationVehicleApplicationIdPut$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Update the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationVehicleApplicationIdPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationVehicleApplicationIdPut$Json(params: V4ApplicationVehicleApplicationIdPut$Json$Params, context?: HttpContext): Observable<ModelsV4ApplicationPublicApplicationUpdateBaseResponseBaseResponse> {
    return this.v4ApplicationVehicleApplicationIdPut$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationPublicApplicationUpdateBaseResponseBaseResponse>): ModelsV4ApplicationPublicApplicationUpdateBaseResponseBaseResponse => r.body)
    );
  }

  /** Path part for operation `v4ApplicationVehicleApplicationIdFilePost()` */
  static readonly V4ApplicationVehicleApplicationIdFilePostPath = '/v4/application/vehicle/{applicationId}/file';

  /**
   * Uploads a related file for the vehicle application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationVehicleApplicationIdFilePost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  v4ApplicationVehicleApplicationIdFilePost$Plain$Response(params: V4ApplicationVehicleApplicationIdFilePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationLoanFileRequestBaseResponse>> {
    return v4ApplicationVehicleApplicationIdFilePost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Uploads a related file for the vehicle application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationVehicleApplicationIdFilePost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  v4ApplicationVehicleApplicationIdFilePost$Plain(params: V4ApplicationVehicleApplicationIdFilePost$Plain$Params, context?: HttpContext): Observable<ModelsV4ApplicationLoanFileRequestBaseResponse> {
    return this.v4ApplicationVehicleApplicationIdFilePost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationLoanFileRequestBaseResponse>): ModelsV4ApplicationLoanFileRequestBaseResponse => r.body)
    );
  }

  /**
   * Uploads a related file for the vehicle application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationVehicleApplicationIdFilePost$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  v4ApplicationVehicleApplicationIdFilePost$Json$Response(params: V4ApplicationVehicleApplicationIdFilePost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationLoanFileRequestBaseResponse>> {
    return v4ApplicationVehicleApplicationIdFilePost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Uploads a related file for the vehicle application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationVehicleApplicationIdFilePost$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  v4ApplicationVehicleApplicationIdFilePost$Json(params: V4ApplicationVehicleApplicationIdFilePost$Json$Params, context?: HttpContext): Observable<ModelsV4ApplicationLoanFileRequestBaseResponse> {
    return this.v4ApplicationVehicleApplicationIdFilePost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationLoanFileRequestBaseResponse>): ModelsV4ApplicationLoanFileRequestBaseResponse => r.body)
    );
  }

  /**
   * Uploads a related file for the vehicle application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationVehicleApplicationIdFilePost$Xml()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  v4ApplicationVehicleApplicationIdFilePost$Xml$Response(params: V4ApplicationVehicleApplicationIdFilePost$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationLoanFileRequestBaseResponse>> {
    return v4ApplicationVehicleApplicationIdFilePost$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Uploads a related file for the vehicle application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationVehicleApplicationIdFilePost$Xml$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  v4ApplicationVehicleApplicationIdFilePost$Xml(params: V4ApplicationVehicleApplicationIdFilePost$Xml$Params, context?: HttpContext): Observable<ModelsV4ApplicationLoanFileRequestBaseResponse> {
    return this.v4ApplicationVehicleApplicationIdFilePost$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationLoanFileRequestBaseResponse>): ModelsV4ApplicationLoanFileRequestBaseResponse => r.body)
    );
  }

  /** Path part for operation `v4ApplicationVehicleApplicationIdWithdrawPost()` */
  static readonly V4ApplicationVehicleApplicationIdWithdrawPostPath = '/v4/application/vehicle/{applicationId}/withdraw';

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationVehicleApplicationIdWithdrawPost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationVehicleApplicationIdWithdrawPost$Json$Plain$Response(params: V4ApplicationVehicleApplicationIdWithdrawPost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse>> {
    return v4ApplicationVehicleApplicationIdWithdrawPost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationVehicleApplicationIdWithdrawPost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationVehicleApplicationIdWithdrawPost$Json$Plain(params: V4ApplicationVehicleApplicationIdWithdrawPost$Json$Plain$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse> {
    return this.v4ApplicationVehicleApplicationIdWithdrawPost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse>): ModelsV4ApplicationApplicationWithdrawRequestBaseResponse => r.body)
    );
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationVehicleApplicationIdWithdrawPost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationVehicleApplicationIdWithdrawPost$Json$Json$Response(params: V4ApplicationVehicleApplicationIdWithdrawPost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse>> {
    return v4ApplicationVehicleApplicationIdWithdrawPost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationVehicleApplicationIdWithdrawPost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationVehicleApplicationIdWithdrawPost$Json$Json(params: V4ApplicationVehicleApplicationIdWithdrawPost$Json$Json$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse> {
    return this.v4ApplicationVehicleApplicationIdWithdrawPost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse>): ModelsV4ApplicationApplicationWithdrawRequestBaseResponse => r.body)
    );
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationVehicleApplicationIdWithdrawPost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationVehicleApplicationIdWithdrawPost$Json$Xml$Response(params: V4ApplicationVehicleApplicationIdWithdrawPost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse>> {
    return v4ApplicationVehicleApplicationIdWithdrawPost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationVehicleApplicationIdWithdrawPost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationVehicleApplicationIdWithdrawPost$Json$Xml(params: V4ApplicationVehicleApplicationIdWithdrawPost$Json$Xml$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse> {
    return this.v4ApplicationVehicleApplicationIdWithdrawPost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse>): ModelsV4ApplicationApplicationWithdrawRequestBaseResponse => r.body)
    );
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationVehicleApplicationIdWithdrawPost$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationVehicleApplicationIdWithdrawPost$Xml$Plain$Response(params: V4ApplicationVehicleApplicationIdWithdrawPost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse>> {
    return v4ApplicationVehicleApplicationIdWithdrawPost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationVehicleApplicationIdWithdrawPost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationVehicleApplicationIdWithdrawPost$Xml$Plain(params: V4ApplicationVehicleApplicationIdWithdrawPost$Xml$Plain$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse> {
    return this.v4ApplicationVehicleApplicationIdWithdrawPost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse>): ModelsV4ApplicationApplicationWithdrawRequestBaseResponse => r.body)
    );
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationVehicleApplicationIdWithdrawPost$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationVehicleApplicationIdWithdrawPost$Xml$Json$Response(params: V4ApplicationVehicleApplicationIdWithdrawPost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse>> {
    return v4ApplicationVehicleApplicationIdWithdrawPost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationVehicleApplicationIdWithdrawPost$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationVehicleApplicationIdWithdrawPost$Xml$Json(params: V4ApplicationVehicleApplicationIdWithdrawPost$Xml$Json$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse> {
    return this.v4ApplicationVehicleApplicationIdWithdrawPost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse>): ModelsV4ApplicationApplicationWithdrawRequestBaseResponse => r.body)
    );
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationVehicleApplicationIdWithdrawPost$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationVehicleApplicationIdWithdrawPost$Xml$Xml$Response(params: V4ApplicationVehicleApplicationIdWithdrawPost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse>> {
    return v4ApplicationVehicleApplicationIdWithdrawPost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationVehicleApplicationIdWithdrawPost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationVehicleApplicationIdWithdrawPost$Xml$Xml(params: V4ApplicationVehicleApplicationIdWithdrawPost$Xml$Xml$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse> {
    return this.v4ApplicationVehicleApplicationIdWithdrawPost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse>): ModelsV4ApplicationApplicationWithdrawRequestBaseResponse => r.body)
    );
  }

}
